import { IndexedDBStore, Stores } from "./IndexedDBStore";

class TOTPSecretStore extends IndexedDBStore {}

export const totpSecretStore = new TOTPSecretStore(Stores.TOTPSecrets);
